<template>
  <span class="user-address-type">
    ({{ label }})
  </span>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'

export default {
  name: 'user-address-type',
  props: {
    userAddress: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    label () {
      if (this.userAddress.businessName) {
        return `${globalize('user-details.lbl-address-type-company')} "${this.userAddress.businessName}"`
      }
      return globalize('user-details.lbl-address-type-individual')
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~@scss/variables';

  .user-address-type {
    color: $_lightRed;
  }
</style>
